<template>
  <div class='EnbCompProds'>
    <div
    class="cont-comp"
    v-for="(c, key) in comps"
    :key="key"
    >
      <div class="cont-input">
        <input type="checkbox" :checked="c.selected" @click="exec(c.name)">
      </div>
      <component :is="c.name" :data="DefaultProdutos[0]"/>  
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Products from '@/components/Products'
export default {
  name: 'EnbCompProds',
  components: { ...Products },
  data () {
    return {
      comps: [
        {
          name: 'EnbItem01',
          selected: true
        },
        {
          name: 'EnbProduto02',
          selected: false
        }
      ],
      DefaultProdutos: [
        {
          id: 9999,
          code: '99999',
          tipo: 'Simples',
          name: 'Seu Produto',
          status: true,
          preco: 1.99,
          oferta: 1.99,
          img: [],
          descricao: 'Descrição do seu produto',
          dateOfertaStart: '',
          dateOfertaEnd: '',
          categoria: '',
          gerEstoque: false,
          statusEstoque: '',
          estoque: 1,
          exibeSemEstoque: true,
          pendencia: '',
          visibilidade: 1,
          visualizacao: 1,
          atributos: [],
          estoqueVariavel: [],
          caracter: [],
          destaque: true,
          dateCreate: new Date(),
          link: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['UpdatePrefComp']),
    exec (value) {
      this.comps = this.comps.map(c => {
        if(c.name === value) {
          c.selected = true
        }
        else {
          c.selected = false
        }
        return c
      })
      this.UpdatePrefComp({ comp: 'componentProd', prop: 'name', value: value })
    }
  },
  created () {
    if(this.Prefes?.componentProd) {
      this.comps = this.comps.map(c => {
        c.selected = c.name === this.Prefes.componentProd.name
        return c
      })
    }
  }
}
</script>

<style scoped>
.EnbCompProds {
  display: flex;
}

.cont-input {
  display: flex;
  align-items: start;
}

.cont-comp {
  margin-left: 1%;
}
</style>
